/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/permission_groups`;

const state = {
    permission_groups: [],
    unassigned_permissions: [],
    assigned_permissions: [],
    permission_group_count: null
};

const getters = {
    allPermissionGroups: state => state.permission_groups,
    getGroupAssignedPermissions: state => state.assigned_permissions,
    getGroupUnassignedPermissions: state => state.unassigned_permissions,
    totalPermissionGroupCount: state => state.permission_group_count
};

const actions = {
    async fetchPermissionGroups({ commit }, payload) {
        try {
            const page = payload.page || null
            let limit = payload.itemsPerPage
            if(limit == -1) {
                limit = 1000
            } 
            const url1 = url + "?page=" + page + "&limit=" + limit
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(url1, {
                headers: { 'x-drmms-token': authToken }
            });
            
            let permission_groups = {
                count: response.data.count,
                rows: response.data.rows.map((group) => ({
                    ...group,
                    date: moment(group.createdAt).format('LLL'),
                }))
            } 
            commit('setPermissionGroups', permission_groups);
        } catch (err) {
            console.log(err);
        }
    },
    async createPermissionGroup({ commit }, body) {

        let add_permissions = state.assigned_permissions.filter(checkPermission => checkPermission.isAssigned === false);

        body.permissions = add_permissions;

        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });
            let newPermissionGroup = Object.assign(response.data, { date: moment(response.data.createdAt).format('LLL'), permissions: add_permissions });
            commit('newPermissionGroup', newPermissionGroup);
            return response.data;
        } catch (err) {
            if (err.response) return { error: true, status: 500, message: 'Internal Server Error' };
            console.log(err);
        }
    },
    async updatePermissionGroup({ commit }, body) {
        let add_permissions = state.assigned_permissions.filter(checkPermission => checkPermission.isAssigned === false);
        let delete_permissions = state.unassigned_permissions.filter(checkPermission => checkPermission.isAssigned === true);

        body.permissions = {
            add: add_permissions,
            delete: delete_permissions
        }

        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: body
            })
            commit('updatePermissionGroup', body);
            return response.data;
        } catch (err) {
            if (err.response) return { error: true, status: 500, message: 'Internal Server Error' };
            console.log(err);
        }
    },
    async deletePermissionGroup({ commit }, id) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: "delete",
                url,
                headers: { "x-drmms-token": authToken },
                data: { id },
            });
            commit('removePermissionGroup', id);
            return response;
        } catch (err) {
            console.log(err);
        }
    },
    async fetchGroupUnassignedPermissions({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(`${url}/unassignedPermissions`, body, {
                headers: { 'x-drmms-token': authToken }
            });
            state.assigned_permissions = body.permissions.map((permission) => ({
                ...permission,
                isAssigned: true,
                color: 'green',
            }));

            let unassigned = response.data.map((permission) => ({
                ...permission,
                isAssigned: false,
                color: 'red',
            }));
            commit('setGroupUnassignedPermissions', unassigned);
        } catch (err) {
            console.log(err);
        }
    },
    addGroupPermission({ commit }, permission) {
        commit('addGroupPermission', permission);
    },
    removeGroupPermission({ commit }, permission) {
        commit('removeGroupPermission', permission);
    },
    selectAllPermissions({ commit }) {
        commit('setAllPermissionSelected');
    }
};

const mutations = {
    setPermissionGroups: (state, groups) => {
        state.permission_groups = groups.rows
        state.permission_group_count = groups.count

    }, 
    newPermission: (state, permission) => state.permissions.push(permission),
    removePermissionGroup: (state, id) => {
        for (let i = 0; i < id.length; i++) {
            state.permission_groups = state.permission_groups.filter(permission => permission.id !== id[i])
        }
    },
    setGroupUnassignedPermissions: (state, permissions) => state.unassigned_permissions = permissions,
    addGroupPermission: (state, permission) => {
        state.assigned_permissions.push(permission);
        state.unassigned_permissions = state.unassigned_permissions.filter(checkPermission => checkPermission.id !== permission.id);
    },
    removeGroupPermission: (state, permission) => {
        state.unassigned_permissions.push(permission);
        state.assigned_permissions = state.assigned_permissions.filter(checkPermission => checkPermission.id !== permission.id);
    },
    updateGroupPermissions: (state, id) => {
        const index = state.users.findIndex(user => user.id === id);
        if (index !== -1) {
            let updated = state.users[index];
            updated.permissions = state.assigned_permissions;
            state.users.splice(index, 1, updated);
            state.unassigned_permissions = [];
            state.assigned_permissions = [];
        }
    },
    updatePermissionGroup: (state, permission_group) => {
        const index = state.permission_groups.findIndex(group => group.id === permission_group.permission_group_id);
        if (index !== -1) {
            permission_group.permissions = state.assigned_permissions;
            state.permission_groups.splice(index, 1, permission_group);
            state.unassigned_permissions = [];
            state.assigned_permissions = [];
        }
    },
    newPermissionGroup: (state, group) => {
        state.permission_groups.push(group);
    },
    setAllPermissionSelected: (state) => {
        let unselected = state.unassigned_permissions;
        let selected = state.assigned_permissions;

        let combinedPerms = selected.concat(unselected);
        state.assigned_permissions = combinedPerms;
        state.unassigned_permissions = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}